import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

// Primereact styles
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Asynchronously load the PrimeReact theme to avoid render-blocking
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://unpkg.com/primereact/resources/themes/lara-light-amber/theme.css';
document.head.appendChild(link);

// Initialize PostHog
if (process.env.REACT_APP_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || 'https://app.posthog.com',
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') console.log('PostHog loaded');
      const root = ReactDOM.createRoot(document.getElementById("root"));
      root.render(
          <React.StrictMode>
            <PostHogProvider client={posthog}>
              <App />
            </PostHogProvider>
          </React.StrictMode>,
      );
    }
  })
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
